/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Practice_Session_CaptionsInputs */



/**
* | output |
* | --- |
* | "Captions" |
*
* @param {Practice_Session_CaptionsInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const practice_session_captions = /** @type {((inputs?: Practice_Session_CaptionsInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Practice_Session_CaptionsInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Ondertiteling")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Sous-titres")
	return /** @type {LocalizedString} */ ("Captions")
});